import {Component, EventEmitter, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import {forkJoin, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {PgTitleComponent} from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';
import { SofToolbarComponent } from './sof-toolbar/sof-toolbar.component';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';

interface SofTemplateDescription {
  id: string;
  description: string;
  sofType: string;
}

interface SofDescription {
  code: string;
  event: string;
  canonical: string;
}

@Component({
  selector: 'app-sof-templates',
  templateUrl: './sof-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class SofTemplatesComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  toolbarComponentType = SofToolbarComponent;

  allSofItems: SofDescription[] = [];
  allSofTemplates: SofTemplateDescription[] = [];
  allSofItemsDtOptions: any;
  sofTemplatesDtOptions: any;
  dtTrigger: Subject<any> = new Subject<any>();

  gridOptions: GridOptions = {};

  constructor(
              private _lookupServiceSpa: LookupServiceSpa,
              private _router: Router,
              private _renderer: Renderer2
  ) {}

  navigate(_router: Router, data: any) {
    _router.navigate(['/vessels/sof/sof-template', data.id]);
  }

  columnDefs = [
    {hederName:'Code', field:'code'},
    {hederName:'Description', field:'event'},
    {hederName:'Canonical description', field:'canonical'},
  ];

  softempColumnDefs = [
    {hederName:'',
      cellRenderer: (params: { data: { id: any; }; }) => {
        const sof = (params.data.id) ? params.data.id : 'Edit';
        return AgGridService.editButtonWithText(this._renderer, this._router, this.navigate, params.data, sof);
      }
    },
    {hederName:'Description', field:'description'},
    {hederName:'Sof Type', field:'sofType'},
  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.title.emit('SOF design');
    forkJoin([
      this._lookupServiceSpa.getLookupItems({categoryName: 'voyage_sof_all'}),
      this._lookupServiceSpa.getLookupItems({categoryName: 'voyage_sof_templates'})
    ]).subscribe(a => {
      this.allSofItems = a[0].items.map(s => (
        {
          code: s.values[0],
          event: s.values[1],
          canonical: s.values[2]
        }
      ));
      this.allSofTemplates = a[1].items.map(s => (
        {
          id: s.values[0],
          description: s.values[1],
          sofType: s.values[2]
        }
      ));
      this.dtTrigger.next(false);
    });
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

}
